import { featureItems } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">平台优势</h2>
          <p className="mt-3 text-sm text-foreground-600">五大核心能力，让追剧变成纯粹的享受</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item, idx) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center group hover:border-primary-300/40 transition-colors cursor-default"
            >
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4 ${
                idx === 0 ? 'bg-primary-500/10' :
                idx === 1 ? 'bg-accent-500/10' :
                idx === 2 ? 'bg-secondary-500/10' :
                idx === 3 ? 'bg-primary-500/10' :
                'bg-accent-500/10'
              }`}>
                <i className={`${item.icon} text-2xl ${
                  idx === 0 || idx === 3 ? 'text-primary-500' :
                  idx === 1 || idx === 4 ? 'text-accent-500' :
                  'text-secondary-500'
                }`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-950 font-heading mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}